import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import TicketLayout from 'src/layouts/v2/TicketLayout';
import type { RouteGroup } from './types';

// Lazy load V2 Office Ticket components
const HandoverTicket = lazy(() => import('src/pages/v2/OfficeTicket/HandoverTicket'));
const AddHandoverTicket = lazy(() => import('src/pages/v2/OfficeTicket/AddHandoverTicket'));

export const officeTicketRoutes: RouteGroup = [
  // Handover Tickets
  {
    path: urlPath.myHandoverTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: HandoverTicket,
    hasSidebar: true
  },
  {
    path: urlPath.handoverTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myHandoverTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.handoverTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: HandoverTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myHandoverTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: HandoverTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.handoverTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: HandoverTicket,
    hasSidebar: true
  },
  {
    path: urlPath.handoverTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddHandoverTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.handoverTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddHandoverTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  }
];
